import script from "./templateName.vue?vue&type=script&lang=ts&setup=true"
export * from "./templateName.vue?vue&type=script&lang=ts&setup=true"

import "./templateName.vue?vue&type=style&index=0&id=29eb88e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29eb88e0"]])

export default __exports__